import localURI from './localURI';
import serverURI from './serverURI';

export const isLocal = process.env.REACT_APP_API_KEY === 'LOCAL';

export const uris = (isLocal) ? localURI : serverURI;

let _authHeader = ''

export const setAuthHeader = (user, password) => {
  _authHeader = 'Basic ' + btoa(user + ':' + password)
}

export const clearAuthHeader = () => {
  _authHeader = ''
}

export const fetchParam = (any) => {
  if (!isLocal) {
    const headers = { 'Content-Type': 'application/json' }
    if (_authHeader) {
      headers['Authorization'] = _authHeader
    }
    return {
      accept: 'application/json',
      method: 'POST',
      body: JSON.stringify(any),
      headers: headers,
    }
  }
};
